import { render, staticRenderFns } from "./ProjectActivityLogs.vue?vue&type=template&id=959193c8&scoped=true&"
import script from "./ProjectActivityLogs.vue?vue&type=script&lang=js&"
export * from "./ProjectActivityLogs.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActivityLogs.vue?vue&type=style&index=0&id=959193c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959193c8",
  null
  
)

export default component.exports